export default {"src":"/_next/static/media/pl.4ca59b6d.svg","height":480,"width":640,"blurWidth":0,"blurHeight":0};